export const SELECT_ALL_MACHINE_VALUE = "__daily-machine-select-all__";

export function getDailyMachineOptions(machines) {
  return [{ label: "Select all", value: SELECT_ALL_MACHINE_VALUE }, ...(machines || [])];
}

export function getAppliedDailyMachineValues(selectedValues, machines) {
  const available = (machines || []).map((machine) => machine.value);
  const selected = new Set(selectedValues || []);
  const inScope = available.filter((value) => selected.has(value));
  return inScope.length === 0 || inScope.length === available.length ? available : inScope;
}

export function toggleAllDailyMachines(selectedValues, machines) {
  const available = (machines || []).map((machine) => machine.value);
  const selected = getAppliedDailyMachineValues(selectedValues, machines);
  return selected.length === available.length && (selectedValues || []).length > 0 ? [] : available;
}

export function getDailyMachineSelectionSummary(selectedValues, machines) {
  const available = (machines || []).map((machine) => machine.value);
  const selected = new Set(selectedValues || []);
  const selectedCount = available.filter((value) => selected.has(value)).length;
  if (selectedCount === 0) return null;
  if (selectedCount === available.length) return "All machines";
  return `${selectedCount} machine${selectedCount === 1 ? "" : "s"} selected`;
}

export function sameMachineValues(left, right) {
  return (left || []).length === (right || []).length
    && (left || []).every((value, index) => value === right[index]);
}
